<template>
  <div class="mt-3">
    <div :id="`sheet_pole_${sheetType}_${pole._id}`" class="report sheet">
      <article :class="{ transparent: isLoading }">
        <div class="sheet-header">
          <div class="header-logo">
            <img
              src="@/assets/images/sesb-logo-report.png"
              v-if="currentUrl == 'https://sesb-api.inference.asia'"
            />
            <img src="@/assets/images/ilsas-logo.png" class="nav-logo" v-else />
            <div class="header-title border-top">
              <strong>{{ filters.type }} Report</strong>
            </div>
          </div>
          <div class="header-info border-left">
            <div class="info-table">
              <div class="table-row border-bottom">
                <div class="table-cell table-head border-right">
                  <p>SOURCE</p>
                </div>
                <div class="table-cell table-cell-long table-head border-right">
                  <p class="pl-1">{{ source }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>POLE NO</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ pole.name }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>DATE</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ dateFormat("date", pole.datetime) }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>TIME</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ dateFormat("time", pole.datetime) }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>POLE TYPE</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ pole.type }} {{ pole.structure_type }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>VOLTAGE</p>
                </div>
                <div class="table-cell border-right">
                  <p>
                    {{
                      voltage.toLowerCase() == "lv" ? voltage : `${voltage} kV`
                    }}
                  </p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>TEMP</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ temperature ? `${temperature} °C` : "n/a" }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>LOAD</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ load ? `${load} A` : "UNKNOWN" }}</p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>PHASE</p>
                </div>
                <div class="table-cell border-right">
                  <p>
                    {{ "ALL" }}
                  </p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>HUMIDITY</p>
                </div>
                <div class="table-cell border-right">
                  <p>{{ humidity ? `${humidity} %` : "n/a" }}</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell table-subhead border-right">
                  <p>COORDINATE</p>
                </div>
                <div class="table-cell table-cell-long border-right">
                  <p>
                    {{ pole.lat ? pole.lat.toFixed(5) : "n/a" }},
                    {{ pole.lng ? pole.lng.toFixed(5) : "n/a" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sheet-components">
          <div class="component-table">
            <div class="table-row border-bottom">
              <div class="table-cell table-head text-center">
                <p>COMPONENT / EQUIPMENT</p>
              </div>
            </div>
            <template v-if="sheetType == 'visual' && pole.type == 'ABC'">
              <div class="table-row border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>TIANG</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>NO. TIANG / NOTIS BAHAYA</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>RENTIS</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>PENGALIR FASA</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>UMBANG</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENEBAT UMBANG</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>EARTH BONDING</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>TAMATAN KABEL</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>JOINT</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>CABLE TRAY</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENANGKAP KILAT</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>SWITCH LINK / LBS / AR</p>
                </div>
              </div>
              <div class="table-row border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>SUSPENSION / DEAD END CLAMP</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>TRIANGULAR BRACKET</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>OTHERS</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>OBSERVATIONS</p>
                </div>
              </div>
            </template>
            <template v-if="sheetType == 'visual' && pole.type != 'ABC'">
              <div class="table-row-alt border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>TIANG</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>NO. TIANG / NOTIS BAHAYA</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>RENTIS</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENGALIR FASA</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>UMBANG</p>
                </div>
              </div>
              <div class="table-row-alt border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>SWITCH LINK / LBS / AR</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PEPALANG (CROSSARM)</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENGALIR BUMI</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>DAWAI KE BUMI (EARTH WIRE)</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>DISC INSULATOR</p>
                </div>
              </div>
              <div class="table-row-alt border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PERANGKAP KILAT PADA TALIAN</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>JUMPER</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PG CLAMPS / CONNECTORS</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>ANTI CLIMBING DEVICE</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>ARCHING HORN</p>
                </div>
              </div>
              <div class="table-row-alt border-bottom">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>LFI</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>EARTH CROSSARM</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>OTHERS</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>OBSERVATIONS</p>
                </div>
                <div class="table-cell bg-gray"></div>
                <div
                  class="table-cell table-subhead border-right bg-gray"
                ></div>
              </div>
            </template>
            <template v-else-if="sheetType == 'thermal'">
              <div class="table-row border-bottom table-row-thermal">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENGALIR FASA</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>SWITCH LINK / LBS / AR</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENGALIR BUMI (SHIELD WIRE)</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>DAWAI KE BUMI (EARTH WIRE)</p>
                </div>
              </div>
              <div class="table-row border-bottom table-row-thermal">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PENANGKAP KILAT PADA TALIAN</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>JUMPER</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>PG CLAMPS / CONNECTOR</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>ARCHING HORN</p>
                </div>
              </div>
              <div class="table-row border-bottom table-row-thermal">
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>EARTH BONDING</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>TAMATAN KABEL</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right border-dark">
                  <p>JOINT</p>
                </div>
                <div class="table-cell border-right">
                  <p class="position-relative text-center font-weight-bold"></p>
                </div>
                <div class="table-cell table-subhead border-right">
                  <p>OTHERS</p>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="sheet-images">
          <div class="images-table">
            <div class="table-row border-bottom">
              <div class="table-cell table-head w-100">
                <p v-if="sheetType == 'visual'" class="text-center">
                  VISUAL IMAGE
                </p>
                <p v-else-if="sheetType == 'thermal'" class="text-center">
                  THERMAL IMAGE
                </p>
              </div>
            </div>
            <div class="table-row row-images border-bottom">
              <div class="table-cell border-right text-center p-0">
                <div
                  class="w-100 h-100 d-flex justify-content-center align-items-center"
                >
                  <img
                    class="clickable"
                    :src="getImageUrl(0)"
                    @click="toggleModal('galleryViewer', true, 0)"
                  />
                </div>
              </div>
              <div class="table-cell border-right text-center p-0">
                <div
                  class="w-100 h-100 d-flex justify-content-center align-items-center"
                >
                  <img
                    class="clickable"
                    :src="getImageUrl(1)"
                    @click="toggleModal('galleryViewer', true, 1)"
                  />
                </div>
              </div>
            </div>
            <div class="table-row row-images border-bottom">
              <div class="table-cell border-right text-center p-0">
                <div
                  class="w-100 h-100 d-flex justify-content-center align-items-center"
                >
                  <img
                    class="clickable"
                    :src="getImageUrl(2)"
                    @click="toggleModal('galleryViewer', true, 2)"
                  />
                </div>
              </div>
              <div class="table-cell border-right text-center p-0">
                <div
                  class="w-100 h-100 d-flex justify-content-center align-items-center"
                >
                  <img
                    class="clickable"
                    :src="getImageUrl(3)"
                    @click="toggleModal('galleryViewer', true, 3)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sheet-remarks">
          <div class="remarks-table">
            <div class="table-row border-bottom">
              <div class="table-cell w-100 text-center">
                <p v-if="sheetType == 'visual'" class="font-weight-bolder">
                  VISUAL DEFECT
                </p>
                <p
                  v-else-if="sheetType == 'thermal'"
                  class="font-weight-bolder"
                >
                  THERMAL DEFECT
                </p>
              </div>
            </div>
            <div class="table-row row-remarks border-bottom">
              <div class="table-cell table-cell-long border-right w-100">
                <p>
                  {{ `No ${sheetType} problem detected` }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="sheet-recommendations">
          <div class="recommendations-table">
            <div class="table-row border-bottom">
              <div class="table-cell w-100 text-center">
                <p class="font-weight-bolder">ANALYSIS &amp; RECOMMENDATION</p>
              </div>
            </div>
            <div class="table-row row-recommendations">
              <div class="table-cell w-100">
                <p v-if="sheetType == 'visual'">
                  {{ pole.visual_remark }}
                </p>
                <p v-else-if="sheetType == 'thermal'">
                  {{ pole.thermal_remark }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
      <loading-spinner
        class="loading-spinner-component"
        v-if="isLoading"
      ></loading-spinner>
    </div>
    <div class="page-break"></div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api.js";
import moment from "moment";
import Swal from "sweetalert2";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "reportSheet",
  props: [
    "source",
    "pole",
    "date",
    "filters",
    "voltage",
    "load",
    "temperature",
    "humidity",
    "sheetType",
  ],
  components: {
    "loading-spinner": LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      visualImages: [],
      thermalImages: [],
      currentUrl: process.env.VUE_APP_API_URL,
    };
  },
  watch: {
    pole: {
      async handler() {
        if (this.pole) {
          this.resizeOverviewSheet();
          await this.fetchDefectImages();
        }
      },
      immediate: true,
    },
  },
  methods: {
    toggleModal(modalName, show, index) {
      if (show) {
        if (modalName === "galleryViewer" && this.getImageUrl(index)) {
          let galleryImageIndex = index;
          let galleryImages = this[`${this.sheetType}Images`].map((vi) =>
            vi.url && vi.url.substring(0, 4) == "http"
              ? vi.url
              : "https://".concat(vi.url)
          );
          this.$emit(
            "toggleModal",
            modalName,
            show,
            galleryImages,
            galleryImageIndex,
            this.sheetType == "thermal"
              ? this.pole.thermal_remark
              : this.pole.visual_remark
          );
        }
      }
    },
    getImageUrl(index) {
      let imageUrl = this[`${this.sheetType}Images`][index];

      if (imageUrl) {
        return imageUrl.url && imageUrl.url.substring(0, 4) == "http"
          ? imageUrl.url
          : "https://".concat(imageUrl.url);
      } else {
        return null;
      }
    },
    async fetchDefectImages() {
      this.visualImages =
        this.pole.visualimage && this.pole.visualimage.length > 0
          ? this.pole.visualimage.sort((a, b) => {
              let aName = a.name ? a.name.toLowerCase() : null;
              let bName = b.name ? b.name.toLowerCase() : null;

              return aName < bName ? -1 : 1;
            })
          : [];
      this.thermalImages =
        this.pole.thermalimages && this.pole.thermalimages.length > 0
          ? this.pole.thermalimages.sort((a, b) => {
              let aName = a.name ? a.name.toLowerCase() : null;
              let bName = b.name ? b.name.toLowerCase() : null;

              return aName < bName ? -1 : 1;
            })
          : [];
    },
    dateFormat(type, date) {
      if (date) {
        if (type === "date") {
          return moment.utc(date).format("DD/MM/YYYY");
        } else if (type === "time") {
          return moment.utc(date).format("h:mm A");
        } else {
          return date;
        }
      } else {
        return "";
      }
    },
    resizeOverviewSheet(skipTimeout) {
      this.isLoading = skipTimeout ? false : true;
      setTimeout(
        () => {
          let elementId = `#sheet_pole_${this.sheetType}_${this.pole._id}`;
          const sheet = $(elementId);
          const sheetWidth = sheet.width();
          sheet.height(sheetWidth * 1.1414285714);
          sheet.css({
            fontSize: sheetWidth * 0.013253012,
          });
          const title = sheet
            .children()
            .children()
            .children()
            .children(".header-title");
          title.css({
            fontSize: sheetWidth * 0.021686746,
          });
          this.isLoading = false;
        },
        skipTimeout ? 10 : 2000
      );
    },
  },
  mounted() {
    $(window).on("resize", (e) => {
      this.resizeOverviewSheet(true);
    });
  },
  beforeDestroy() {
    $(window).off("resize");
  },
};
</script>

<style lang="scss">
@import url("../assets/css/print.scss");

.bg-gray {
  background-color: #f5f7fa !important;
}

.sheet {
  width: 100% !important;
  height: auto;
  position: relative;

  article {
    width: 100%;
    height: 100%;
    display: block;

    &.transparent {
      opacity: 0;
    }

    .sheet-header {
      height: 13%;

      .header-logo {
        display: inline-block;
        vertical-align: top;
        width: 20%;
        height: 100%;

        img {
          width: 100%;
          height: auto;
          padding: 5px;
        }

        .header-title {
          height: 27%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .header-info {
        display: inline-block;
        vertical-align: top;
        width: 80%;
        height: 100%;

        .info-table {
          width: 100%;
          height: 100%;

          .table-row {
            height: 20%;

            .table-cell {
              width: 16.666666667%;

              &.table-cell-long {
                width: 83.333333333%;
              }
            }
          }
        }
      }
    }

    .sheet-components {
      height: 15%;

      .component-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 20%;

          &.table-row-thermal {
            height: 26.666666667%;
          }

          .table-cell {
            width: 5%;

            &.table-head {
              width: 100%;
            }

            &.table-subhead {
              width: 20%;
            }
          }
        }

        .table-row-alt {
          height: 20%;

          &.table-row-thermal {
            height: 26.666666667%;
          }

          .table-cell {
            width: 3%;

            &.table-head {
              width: 100%;
            }

            &.table-subhead {
              width: 17%;
            }
          }
        }
      }
    }

    .sheet-images {
      height: 52%;

      .images-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 5%;

          &.row-images {
            height: 47.5%;
          }

          .table-cell {
            width: 50%;
          }
        }
      }
    }

    .sheet-remarks {
      height: 10%;

      .remarks-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 25%;

          &.row-remarks {
            height: 75%;
          }

          .table-cell {
            width: 20%;

            &.table-cell-long {
              width: 80%;
            }

            .inner-row {
              width: 100%;
              height: 33.5%;
              position: relative;

              &:nth-child(odd) {
                height: 33.25%;
              }

              .inner-cell {
                position: relative;
                display: inline-block;
                vertical-align: top;
                height: 100%;
                width: 25%;

                p {
                  margin: 0;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(10%, -50%);
                  line-height: 110%;
                  width: 100%;
                  padding: 0px 3%;
                }
              }

              .inner-cell-long {
                position: relative;
                display: inline-block;
                vertical-align: top;
                height: 100%;
                width: 75%;

                p {
                  margin: 0;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(10%, -50%);
                  line-height: 110%;
                  width: 100%;
                  padding: 0px 3%;
                }
              }
            }
          }
        }
      }
    }

    .sheet-recommendations {
      height: 10%;

      .recommendations-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 25%;

          &.row-recommendations {
            height: 75%;
          }
        }
      }
    }

    .table-cell {
      position: relative;
      display: inline-block;
      vertical-align: top;
      padding: 0px 1%;
      height: 100%;

      p {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        line-height: 110%;
        width: 100%;
        padding: 0px 3%;
      }

      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        display: block;
        object-fit: cover;
      }
    }

    .table-head {
      color: #ffffff;
      background-color: #004c9c;
      font-weight: 500;
    }

    .table-subhead {
      background-color: #bdd7ee;
    }
  }
}
</style>
